<script lang="ts">
    export let message: string;
</script>

<section>
    {message}
</section>
